<div class="tab-group">
  <a [routerLink]="coditasRoute" class="tab-item" routerLinkActive="active">
    {{ workspaceName }}
  </a>
  <a [routerLink]="personalRoute" class="tab-item" routerLinkActive="active">
    Personal
  </a>
</div>
